<h3 mat-dialog-title>{{ data.title }}</h3>
@if (data.message) {
  <div mat-dialog-content >
    <p>{{ data.message }}</p>
  </div>
}
<div mat-dialog-actions >
  @for (action of data.actions; track action) {
    <button
      mat-raised-button
      [disabled]="action.disabled"
      [color]="action.color"
      (click)="action.action()"
      data-test="action-button"
      >
      {{ action.name }}
    </button>
  }
</div>
